let isPlayerVisible = false;
let currentAudiobook = null;
let currentButton = null;
let isAudioPlaying = false;
let currentWidget = null;
let isFromSlideshow = false;

function showPlayer(audiobookData = null, fromSlideshow = false) {
  const player = document.getElementById('fixed-bar-audio-player');
  if (!player) return;

  if (audiobookData) {
    resetAllSlideshowButtons();
    updatePlayerContent(audiobookData);
    currentAudiobook = audiobookData;
    isFromSlideshow = fromSlideshow;
    if (fromSlideshow && currentButton) {
      updateButtonState(true, false);
    }
  }

  player.classList.add('fixed-bar-audio-player--visible');
  isPlayerVisible = true;
}

function hidePlayer() {
  const player = document.getElementById('fixed-bar-audio-player');
  if (!player) return;

  stopAllAudio();

  setTimeout(() => {
    player.classList.remove('fixed-bar-audio-player--visible');
    isPlayerVisible = false;

    resetAllSlideshowButtons();
    resetButtonLabel();

    currentAudiobook = null;
    currentButton = null;
    currentWidget = null;
    isFromSlideshow = false;
  }, 200);
}

function updatePlayerContent(audiobookData) {
  const image = document.getElementById('player-audio-image');
  const iframeContainer = document.getElementById('player-audio-iframe');

  if (image && audiobookData.image) {
    image.src = audiobookData.image;
    image.alt = audiobookData.title || 'Capa do audiolivro';
  }

  if (iframeContainer && audiobookData.iframe) {
    iframeContainer.innerHTML = audiobookData.iframe;
    
    const iframe = iframeContainer.querySelector('iframe');
    if (iframe && iframe.src.includes('soundcloud.com')) {
      if (!iframe.src.includes('auto_play=true')) {
        const separator = iframe.src.includes('?') ? '&' : '?';
        iframe.src = iframe.src + separator + 'auto_play=true';
      }
    }
    
    setTimeout(setupIframeListeners, 200);
  }
}

function setupIframeListeners() {
  const iframe = document.querySelector('#player-audio-iframe iframe');
  if (!iframe) return;

  iframe.addEventListener('focus', () => trackAudioInteraction('focus'));
  iframe.addEventListener('click', () => trackAudioInteraction('click'));

  iframe.addEventListener('load', () => {
    if (iframe.src.includes('soundcloud.com')) {
      setupSoundCloudWidget(iframe);
    } else {
      setupGenericIframeTracking(iframe);
    }
  });

  iframe.addEventListener('error', () => {
    console.error('Erro ao carregar iframe');
  });

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
        trackAudioInteraction('url_change');
      }
    });
  });

  observer.observe(iframe, { attributes: true });

  if (iframe.complete) {
    iframe.src.includes('soundcloud.com')
      ? setupSoundCloudWidget(iframe)
      : setupGenericIframeTracking(iframe);
  }
}

function setupSoundCloudWidget(iframe) {
  try {
    if (typeof SC !== 'undefined') {
      currentWidget = SC.Widget(iframe);

      if (!currentWidget) return;

      let autoPlayAttempted = false;

      currentWidget.bind(SC.Widget.Events.READY, () => {
        if (!autoPlayAttempted) {
          autoPlayAttempted = true;
          setTimeout(() => {
            try {
              if (currentWidget && currentWidget.play) {
                currentWidget.play();
              }
            } catch (e) {
              console.error('Erro ao tocar automaticamente:', e);
            }
          }, 300);
        }
      });

      currentWidget.bind(SC.Widget.Events.PLAY, () => {
        isAudioPlaying = true;
        updateButtonState(true, false);
        trackAudioInteraction('soundcloud_play', currentAudiobook);
      });

      currentWidget.bind(SC.Widget.Events.PAUSE, () => {
        isAudioPlaying = false;
        updateButtonState(false, true);
        trackAudioInteraction('soundcloud_pause', currentAudiobook);
      });

      currentWidget.bind(SC.Widget.Events.FINISH, () => {
        isAudioPlaying = false;
        updateButtonState(false, false);
        trackAudioInteraction('soundcloud_finish', currentAudiobook);
      });

      if (!autoPlayAttempted) {
        setTimeout(() => {
          if (currentWidget && currentWidget.play && !autoPlayAttempted) {
            autoPlayAttempted = true;
            try {
              currentWidget.play();
            } catch (e) {
              console.error('Erro ao tocar automaticamente (fallback):', e);
            }
          }
        }, 1000);
      }
    } else if (!document.querySelector('script[src*="soundcloud.com"]')) {
      const script = document.createElement('script');
      script.src = 'https://w.soundcloud.com/player/api.js';
      script.onload = () => setTimeout(() => setupSoundCloudWidget(iframe), 500);
      document.head.appendChild(script);
    }
  } catch (err) {
    console.error(err);
  }
}

function setupGenericIframeTracking(iframe) {
  iframe.addEventListener('message', event => {
    trackAudioInteraction('iframe_message', event.data);

    if (typeof event.data !== 'object') return;

    if (['play'].includes(event.data.event || event.data.action)) {
      isAudioPlaying = true;
      updateButtonState(true, false);
    } else if (['pause'].includes(event.data.event || event.data.action)) {
      isAudioPlaying = false;
      updateButtonState(false, true);
    }
  });

  let playState = false;

  iframe.addEventListener('load', () => {
    if (playState) {
      isAudioPlaying = false;
      playState = false;
    }
  });

  iframe.addEventListener('click', () => {
    if (!playState) {
      playState = true;
      isAudioPlaying = true;

      setTimeout(() => {
        if (isAudioPlaying) {
          isAudioPlaying = false;
        }
      }, 5000);
    }
  });
}

function stopAllAudio() {
  if (currentWidget?.pause) {
    try {
      currentWidget.pause();
    } catch (error) {
      console.error(error);
    }
  }

  const iframe = document.querySelector('#player-audio-iframe iframe');
  if (!iframe) return;

  if (!iframe.contentWindow || !iframe.contentWindow.postMessage) {
    return;
  }

  try {
    if (iframe.contentWindow && typeof iframe.contentWindow.postMessage === 'function') {
      ['action', 'command', 'event', 'type'].forEach(key =>
        iframe.contentWindow.postMessage({ [key]: 'pause' }, '*')
      );
    }

    try {
      const doc = iframe.contentDocument;
      if (doc && doc.querySelectorAll) {
        doc.querySelectorAll('audio, video').forEach(media => media.pause?.());
      }
    } catch (docError) {
      console.error(docError.message);
    }

    try {
      const src = iframe.src;
      if (src) {
        iframe.src = '';
        setTimeout(() => {
          if (iframe && iframe.src === '') {
            iframe.src = src;
          }
        }, 50);
      }
    } catch (reloadError) {
      console.error(reloadError.message);
    }

  } catch (err) {
    console.error(err);
  }

  isAudioPlaying = false;
  resetAllSlideshowButtons();
}

function getDefaultButtonLabel(button) {
  return button?.dataset?.defaultLabel || 'Ouvir amostra';
}

function updateButtonState(isPlaying, isPaused = false) {
  if (!currentButton) return;
  
  const btnText = currentButton.querySelector('.button__text');
  if (btnText) {
    if (isPlaying) {
      const playingLabel = currentButton.dataset?.playingLabel || 'Ouvindo amostra';
      btnText.textContent = playingLabel;
      currentButton.classList.add('is-playing');
      currentButton.classList.remove('is-paused');
    } else if (isPaused && isPlayerVisible) {
      const pausedLabel = currentButton.dataset?.pausedLabel || 'Pausado';
      btnText.textContent = pausedLabel;
      currentButton.classList.remove('is-playing');
      currentButton.classList.add('is-paused');
    } else {
      const defaultLabel = getDefaultButtonLabel(currentButton);
      btnText.textContent = defaultLabel;
      currentButton.classList.remove('is-playing');
      currentButton.classList.remove('is-paused');
    }
  }
}

function resetPlayerButton(button) {
  const btnText = button?.querySelector('.button__text');
  if (btnText) {
    btnText.textContent = getDefaultButtonLabel(button);
  }
  button?.classList.remove('is-playing');
  button?.classList.remove('is-paused');
}

function resetButtonLabel() {
  if (currentButton) {
    resetPlayerButton(currentButton);
  }
  isAudioPlaying = false;
}

function resetAllSlideshowButtons() {
  document.querySelectorAll('.button.button--player').forEach(button => {
    resetPlayerButton(button);
  });
}

function trackAudioInteraction(action, data = null) {
  const payload = {
    action,
    timestamp: new Date().toISOString(),
    audiolivro: currentAudiobook
      ? {
          variantId: currentAudiobook.variantId,
          title: currentAudiobook.title
        }
      : null,
    additionalData: data
  };
}

function getAudiobookFromSlideshow(variantId) {
  const button = document.querySelector(`[data-audiolivro-id="${variantId}"]`);
  if (!button) return null;

  const slide = button.closest('.slideshow__slide');
  if (!slide) return null;

  return {
    variantId,
    image: slide.querySelector('.slideshow__image-wrapper img')?.src || '',
    title: slide.querySelector('.banner__heading')?.textContent.trim() || '',
    iframe: button.getAttribute('data-audio-iframe') || ''
  };
}

function getAudiobookFromProductPnld(button) {
  if (!button) return null;

  const section = button.closest('.product-pnld');
  if (!section) return null;

  return {
    variantId: button.getAttribute('data-pnld-player-id') || 'pnld',
    image: button.getAttribute('data-product-image') || section.querySelector('.product-pnld__media img')?.src || '',
    title: button.getAttribute('data-product-title') || section.querySelector('.product-pnld__title')?.textContent.trim() || '',
    iframe: button.getAttribute('data-audio-iframe') || ''
  };
}

function getAudiobookFromCard(card) {
  if (!card) return null;

  const variantId = card.getAttribute('data-audiolivro-id');
  const iframe = card.getAttribute('data-audio-iframe');
  
  if (variantId && iframe) {
    return {
      variantId,
      image: card.getAttribute('data-product-image'),
      title: card.getAttribute('data-product-title'),
      iframe
    };
  }
  return null;
}

function togglePlayPause() {
  if (!currentWidget) {
    console.warn('Widget não disponível para toggle');
    return false;
  }
  
  try {
    if (isAudioPlaying) {
      currentWidget.pause();
    } else {
      currentWidget.play();
    }
    return true;
  } catch (error) {
    console.error('Erro ao alternar play/pause:', error);
    
    try {
      currentWidget.isPaused(isPaused => {
        if (isPaused) {
          currentWidget.play();
        } else {
          currentWidget.pause();
        }
      });
      return true;
    } catch (e) {
      console.error('Erro ao alternar play/pause (fallback):', e);
      return false;
    }
  }
}

function isSameAudiobook(data) {
  if (!currentAudiobook || !data) return false;
  
  const currentId = String(currentAudiobook.variantId || '').trim();
  const newId = String(data.variantId || '').trim();
  
  return currentId === newId && currentId !== '';
}

document.addEventListener('click', event => {
  const buttonPlayer = event.target.closest('.button.button--player');

  if (buttonPlayer?.closest('.product-pnld')) {
    event.preventDefault();
    event.stopPropagation();
    
    const data = getAudiobookFromProductPnld(buttonPlayer);
    
    if (data?.iframe) {
      const sameAudio = isSameAudiobook(data);
            
      if (isPlayerVisible && sameAudio && currentWidget) {
        togglePlayPause();
      } else {
        if (currentButton && currentButton !== buttonPlayer) {
          resetPlayerButton(currentButton);
        }
        currentButton = buttonPlayer;
        showPlayer(data, true);
      }
    }
    return;
  }

  if (buttonPlayer?.closest('.slideshow-audiobooks')) {
    event.preventDefault();
    const variantId = buttonPlayer.getAttribute('data-audiolivro-id');
    const data = getAudiobookFromSlideshow(variantId);

    if (data) {
      const sameAudio = isSameAudiobook(data);
      
      if (isPlayerVisible && sameAudio && currentWidget) {
        togglePlayPause();
      } else {
        if (currentButton && currentButton !== buttonPlayer) {
          resetPlayerButton(currentButton);
        }
        currentButton = buttonPlayer;
        showPlayer(data, true);
      }
    }
    return;
  }

  const cardSample = event.target.closest('.card__audiobook-sample');
  if (cardSample) {
    const data = getAudiobookFromCard(cardSample);
    if (data) {
      currentButton = {
        querySelector: selector => {
          if (selector === '.button__text') {
            return { textContent: 'Ouvir amostra' };
          }
          return null;
        }
      };
      showPlayer(data, false);
    }
    return;
  }

  const iframe = event.target.closest('iframe');
  if (iframe) {
    const cardSample = iframe.closest('.card__audiobook-sample');
    if (cardSample) {
      const data = getAudiobookFromCard(cardSample);
      if (data) {
        currentButton = {
          querySelector: selector => {
            if (selector === '.button__text') {
              return { textContent: 'Ouvir amostra' };
            }
            return null;
          }
        };
        showPlayer(data, false);
      }
    }
    return;
  }

  if (event.target.closest('#fixed-bar-audio-player')) {
    return;
  }
});

document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && isPlayerVisible) {
    hidePlayer();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const closeButton = document.getElementById('close-player-btn');
  if (closeButton) {
    closeButton.addEventListener('click', hidePlayer);
  }
});